import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import errorToast from "../../../../helper-components/error-toast";
import LoadingSpinner from "../../../../helper-components/loading-spinner";
import { Field, Form, Formik } from "formik";
import AddButton from "../../../../buttons/button";
import DeleteIcon from "../../../../../assets/icons/delete-icon";
import successToast from "../../../../helper-components/success-toast";
import {
  paymentTypeListAction,
  paymentTypeCreateAction,
  paymentTypeUpdateAction,
  paymentTypeDeleteAction,
} from "../../../../../redux/actions/settings-action";

function PaymentTypeComp({
  pageLoading,
  setPageLoading,
  searchValue,
  setReload,
  reload,
}) {
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const tableHeading = [
    "Payment Code",
    "Payment Name",
    "Description",
    "Actions",
  ];
  const initialValues = {
    data: initialData,
    newLine: {
      payment_code: "",
      payment_name: "",
      description: "",
    },
  };
  const dispatch = useDispatch();

  const onSuccess = (data) => {
    const raw = data?.data?.paymentModes ?? [];
    const list = Array.isArray(raw)
      ? raw.map((item) => ({
          id: item.id,
          payment_code: item.payment_code ?? item.paymentType ?? "",
          payment_name: item.payment_name ?? item.paymentType ?? "",
          description: item.description ?? "",
        }))
      : [];
    setItemTypeData(list);
    setLoading(false);
  };

  const onSaveSuccess = (data) => {
    fetchData();
    setLoading(false);
    successToast(data?.message);
  };

  const onSaveError = (data) => {
    fetchData();
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const fetchData = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    dispatch(paymentTypeListAction(onSuccess, onError));
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 800);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    if (debouncedSearchValue !== "" || searchValue === "") {
      fetchData();
    }
  }, [debouncedSearchValue]);

  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };

  const onSubmit = (values) => {
    if (!loading) {
      const changedObjects = [];
      let newLineObject = null;

      initialData?.forEach((item, index) => {
        if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
          changedObjects.push(values.data[index]);
        } else return;
      });

      if (
        JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
      ) {
        if (
          values.newLine.payment_code === "" ||
          values.newLine.payment_name === ""
        ) {
          errorToast("Payment Code and Name are required");
        } else newLineObject = values.newLine;
      }

      if (newLineObject !== null) {
        setLoading(true);
        dispatch(
          paymentTypeCreateAction(
            { paymentTypes: [newLineObject] },
            onSaveSuccess,
            onSaveError
          )
        );
      }

      if (changedObjects.length > 0) {
        setLoading(true);
        let cleanData = [...changedObjects];
        cleanData.forEach((item, _) => {
          delete item?.created_date;
          delete item?.update_date;
        });
        dispatch(
          paymentTypeUpdateAction(
            { paymentTypes: cleanData },
            onSaveSuccess,
            onSaveError
          )
        );
      }
    }
  };

  const onClickDelete = (id) => {
    if (!loading) {
      setLoading(true);
      dispatch(paymentTypeDeleteAction(id, onSaveSuccess, onSaveError));
    }
  };

  useEffect(() => {
    if (reload) {
      fetchData();
      setReload(false);
    }
  }, [reload]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Form className="pt-1">
          <div
            className="flex flex-col justify-between rounded-xl"
            style={{ height: "74vh" }}
          >
            {loading ? (
              <LoadingSpinner />
            ) : (
              <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading?.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {values?.data?.map((item, index) => (
                      <tr
                        className={` bg-[var(--list-table-row-bg)]
                         h-[50px] `}
                        key={index}
                      >
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            maxLength={20}
                            onChange={(e) => {
                              const originalValue = e.target.value;
                              const value = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );
                              if (originalValue !== value) {
                                errorToast(
                                  "Only letters and numbers are allowed"
                                );
                              }
                              handleFieldChange(
                                `data[${index}]`,
                                "payment_code",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].payment_code`}
                            placeholder="Enter Code"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                          <Field
                            maxLength={20}
                            onChange={(e) => {
                              let value = e.target.value;
                              const originalValue = value;
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                              if (originalValue !== value) {
                                errorToast(
                                  "Only letters, numbers, and spaces are allowed"
                                );
                              }
                              value = value.replace(/^\s+/, "");
                              if (value !== value.replace(/\s+/g, " ")) {
                                errorToast(
                                  "Consecutive spaces are not allowed"
                                );
                              }
                              value = value.replace(/\s+/g, " ");
                              handleFieldChange(
                                `data[${index}]`,
                                "payment_name",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].payment_name`}
                            placeholder="Enter Name"
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                          <Field
                            maxLength={80}
                            onChange={(e) => {
                              let value = e.target.value;
                              const originalValue = value;
                              value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                              if (originalValue !== value) {
                                errorToast(
                                  "Only letters, numbers, and spaces are allowed"
                                );
                              }
                              value = value.replace(/^\s+/, "");
                              if (value !== value.replace(/\s+/g, " ")) {
                                errorToast(
                                  "Consecutive spaces are not allowed"
                                );
                              }
                              value = value.replace(/\s+/g, " ");
                              handleFieldChange(
                                `data[${index}]`,
                                "description",
                                value,
                                setFieldValue
                              );
                            }}
                            name={`data[${index}].description`}
                            placeholder="Enter Description"
                            className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-2"
                          />
                        </td>
                        <td className="tab-cell align-middle text-sm fw_400 text-secondary w-1/12 ">
                          <div className="flex items-center">
                            <button
                              type="button"
                              onClick={() => onClickDelete(item?.id)}
                            >
                              <DeleteIcon />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          maxLength={20}
                          onChange={(e) => {
                            const originalValue = e.target.value;
                            const value = e.target.value.replace(
                              /[^a-zA-Z0-9]/g,
                              ""
                            );
                            if (originalValue !== value) {
                              errorToast(
                                "Only letters and numbers are allowed"
                              );
                            }
                            handleFieldChange(
                              `newLine`,
                              "payment_code",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.payment_code"
                          placeholder="Enter Code"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-2/12">
                        <Field
                          maxLength={20}
                          onChange={(e) => {
                            let value = e.target.value;
                            const originalValue = value;
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                            if (originalValue !== value) {
                              errorToast(
                                "Only letters, numbers, and spaces are allowed"
                              );
                            }
                            value = value.replace(/^\s+/, "");
                            if (value !== value.replace(/\s+/g, " ")) {
                              errorToast(
                                "Consecutive spaces are not allowed"
                              );
                            }
                            value = value.replace(/\s+/g, " ");
                            handleFieldChange(
                              `newLine`,
                              "payment_name",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.payment_name"
                          placeholder="Enter Name"
                          className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-7/12">
                        <Field
                          maxLength={80}
                          onChange={(e) => {
                            let value = e.target.value;
                            const originalValue = value;
                            value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                            if (originalValue !== value) {
                              errorToast(
                                "Only letters, numbers, and spaces are allowed"
                              );
                            }
                            value = value.replace(/^\s+/, "");
                            if (value !== value.replace(/\s+/g, " ")) {
                              errorToast(
                                "Consecutive spaces are not allowed"
                              );
                            }
                            value = value.replace(/\s+/g, " ");
                            handleFieldChange(
                              `newLine`,
                              "description",
                              value,
                              setFieldValue
                            );
                          }}
                          name="newLine.description"
                          placeholder="Enter Description"
                          className="w-full border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-2"
                        />
                      </td>
                      <td className="tab-cell text-sm fw_400 text-secondary w-1/12"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            <div className="mt-auto flex gap-3 items-center justify-end w-full h-[4rem]">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default PaymentTypeComp;
